export const UploadHistoryEn = {
  AreyousureyouwanttoaccepttheOrder:
    'Are you sure you want to accept the Order?',
  SelectShipweek: 'Select Shipweek:',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  BulkUpload: 'Change Request Upload',
  Home: 'Home',
  DownloadChangeRequestWithTypeOfRequests: 'Download change request with type of requests',
  DownloadChangeRequestWithTypeOfRequestsBuyer: 'Download Template',
  SelectPOSKUsDownload:"Select PO SKUs & Download",
  SelectAChangeRequestType: 'Select a change request type',
  Download: "Download Template",
  POSkuList:"PO-SKU List",
  ValidateAndDownload:"Validate & Download Template",
  Alert:"Enter multiple PO SKUs separated by commas. You can enter up to 500 PO SKUs.",
  PORevisionAlert: "Enter multiple PO SKUs separated by commas. You can enter up to 1000 PO SKUs.",
  Subtext:"Enter the SKUs you want to include in the download.",
  UploadYourResponseToOpenChangeRequests: 'Upload your response to open change requests',
  UploadYourResponseToOpenChangeRequestsBuyer: 'Upload your response',
  ClickToUploadOrDragAndDrop: 'Click to upload or drag and drop',
  SupportedFile: 'Supported File',
  Upload: 'Upload',
  ChangeType: 'Change Type',
  UploadHistory: 'Upload History',
  SelectStartDate: 'Select Start Date',
  SelectEndDate: "Select End Date",
  UploadType: "Upload Type",
  Filter: 'Filter',
  SrNo: "Sr No",
  UploadFileName: 'Upload File Name',
  Status: "Status",
  TotalCount: 'Total Count',
  ValidCount: 'Valid Count',
  InvalidCount: 'Invalid Count',
  UpdatedAt: 'Updated At',
  Page: "Page",
  GoTO: "Go to",
  Show: "Show",
  FileSuccessfullyDownloaded: "File Successfully Downloaded",
  FileUploadedSuccessfully: "File uploaded successfully.",
  UploadError: "Invalid file type! Please upload an Excel file ",
  QuickGuide: "Quick Guide",
   NoDataAvailable: "No data available",
   UploadedBy: "Uploaded By",
   NoActionTaken:"No Action Taken",
   SelectVendor:"Select Vendor",
   SelectInventoryAnalyst:"Select Inventory Analyst",
   SelectSKU:"Select SKU",
   SelectFat: " Select Change Type",
   Note: "Note : The system allows a maximum of 500 records per download. Please apply filters to limit the results within this threshold.",
   PORevisionNote: "Note : The system allows a maximum of 1000 records per download. Please apply filters to limit the results within this threshold.",
   fatbulkupload: "PO Revision Upload"
}

export const UploadHistoryMN = {
  BulkUpload: '变更请求上传',
  Home: '主页',
  DownloadChangeRequestWithTypeOfRequests: '根据请求类型下载变更请求',
  DownloadChangeRequestWithTypeOfRequestsBuyer: '下载模板',
  SelectPOSKUsDownload:"选择采购订单 SKU 并下载",
  SelectAChangeRequestType: '选择变更请求类型',
  Download: '下载模板',
  POSkuList:"采购订单库存清单",
  Subtext:"输入您希望包含在下载包中的 SKU。",
  Alert: "请输入多个采购订单SKU，以逗号分隔。最多可输入500个采购订单SKU。",
  ValidateAndDownload:"验证并下载模板",
  UploadYourResponseToOpenChangeRequests: '上传您对未关闭变更请求的响应',
  UploadYourResponseToOpenChangeRequestsBuyer: '上传您的回复',
  ClickToUploadOrDragAndDrop: '点击上传或拖放文件',
  SupportedFile: '支持的文件',
  Upload: '上传',
  UploadHistory: '上传历史',
  ChangeType: '变更类型',
  SelectStartDate: '选择开始日期',
  SelectEndDate: '选择结束日期',
  Filter: '筛选',
  SrNo: '序号',
  UploadFileName: '上传文件名',
  Status: '状态',
  TotalCount: '总数',
  ValidCount: '有效数量',
  InvalidCount: '无效数量',
  UpdatedAt: '更新时间',
  Page: '页面',
  GoTO: '跳转到',
  Show: '显示',
  FileSuccessfullyDownloaded: "文件已成功下载",
  FileUploadedSuccessfully: "文件上传成功。",
  UploadError: "文件类型无效！请上传 Excel 文件",
  QuickGuide:"快速指南",
  NoDataAvailable: "暂无数据",
  UploadedBy: "上传者",
  NoActionTaken:"未采取任何行动",
  SelectVendor: "选择供应商",
SelectInventoryAnalyst: "选择库存分析员",
SelectSKU: "选择 SKU",
Note: "注意：系统每次下载最多允许 500 条记录。请使用筛选条件将结果限制在此范围内。"
}
export const HistoryDetailsEn = {
  ReviewDetails: 'Review Details',
  BulkUpload: 'Change Request Upload',
  PORevision: "PO Revision Upload",
  FileName: 'File Name',
  Status: 'Status',
  UploadedBy: 'Uploaded By',
  TotalRecords: 'Total Records',
  ValidRecords: 'Valid Records',
  InvalidRecords: 'Invalid Records',
  Download: 'Download',
  SrNo: 'Sr No',
  IDOpenRequest: 'ID Open Request',
  PONumber: 'PO Number',
  SKU: 'SKU',
  RequestType: 'Request Type',
  CreatedBy: 'Created By',
  Error: 'Error',
  Page: 'Page',
  GoTO: 'Go to',
  Show: 'Show',
  FileSuccessfullyDownloaded: "File Successfully Downloaded",
  NoActionTaken:"No Action Taken"
}
export const HistoryDetailsMN = {
  ReviewDetails: '审核详情',
  BulkUpload: '变更请求上传',
  FileName: '文件名',
  Status: '状态',
  UploadedBy: '上传者',
  TotalRecords: '记录总数',
  ValidRecords: '有效记录',
  InvalidRecords: '无效记录',
  Download: '下载',
  SrNo: '序号',
  IDOpenRequest: '开放请求编号',
  PONumber: '采购订单号',
  SKU: '库存单位',
  RequestType: '请求类型',
  CreatedBy: '创建者',
  Error: '错误',
  Page: '页面',
  GoTO: '跳转到',
  Show: '显示',
  FileSuccessfullyDownloaded: "文件已成功下载",
  NoActionTaken:"未采取任何行动",
  PORevision: "采购订单修订上传"
}

export const quickGuideEN = {
  title: "PO Change Request Upload Quick Guide",
  subtitle: "Easily upload multiple PO requests at once using the Bulk Upload feature.",
  stepsTitle: "Steps to Use",

  step1_title: "Download the template",
  step1_detail1: "Choose a __bold__Request Type__bold__ (Expedite, Defer, Delay, Divert, Open, Confirm, or All).",
  step1_detail1_buyer: "Choose a __bold__Inventory Aanalyst, Vendor and SKU__bold__. At least one filter should be selected to download the template",
  step1_detail2: "Selecting __bold__All__bold__ downloads an Excel file with separate sheets for each type.",

  step2_title: "Fill the template",
  step2_detail1: "Open the Excel file and fill in only the __bold__yellow highlighted (editable)__bold__ fields.",
  step2_detail2: "Non-editable columns are system-protected to prevent accidental changes.",

  step3_title: "Upload the file",
  step3_detail1: "Click __bold__Upload File__bold__ or drag and drop the completed Excel file.",
  step3_detail2: "The system validates your data and updates the __bold__Upload History__bold__ automatically.",

  step4_title: "Review upload summary",
  step4_detail1: "View the count of __bold__Valid__bold__ and __bold__Invalid__bold__ records.",
  step4_detail2: "Click on counts to see detailed record lists.",

  step5_title: "Fix invalid records and re-upload",
  step5_detail1: "Download the __bold__Error File__bold__ with detailed messages.",
  step5_detail2: "Correct the issues and __bold__re-upload__bold__ only the invalid entries.",

  tipsTitle: "Tips",
  tip1: "Ensure all __bold__mandatory fields__bold__ are filled and data formats are correct.",
  tip2: "__bold__Freeze panes__bold__ and use __bold__filters__bold__ in the Excel template for easier editing.",
  tip3: "Check the __bold__Upload History__bold__ regularly to confirm processing status.",

  footer: "Need help? Contact your Admin or check the user guide for more details."
};

export const quickGuideMN = {

  title: "PO批量上传快速指南",
  subtitle: "使用批量上传功能轻松一次性上传多个PO请求。",
  stepsTitle: "使用步骤",

  step1_title: "下载模板",
  step1_detail1: "选择 __bold__请求类型__bold__（加急、延迟、推迟、改道、打开、确认或全部）。",
  step1_detail1_buyer:"请选择一个 __bold__库存分析员、供应商和 SKU__bold__。至少需要选择一个筛选条件才能下载模板",
  step1_detail2: "选择 __bold__全部__bold__ 将下载一个包含每种类型单独工作表的Excel文件。",

  step2_title: "填写模板",
  step2_detail1: "打开Excel文件，仅填写 __bold__黄色高亮（可编辑）__bold__ 字段。",
  step2_detail2: "不可编辑列是系统保护的，以防止意外更改。",

  step3_title: "上传文件",
  step3_detail1: "点击 __bold__上传文件__bold__ 或拖放已完成的Excel文件。",
  step3_detail2: "系统会验证您的数据并自动更新 __bold__上传历史__bold__。",

  step4_title: "查看上传摘要",
  step4_detail1: "查看 __bold__有效__bold__ 和 __bold__无效__bold__ 记录的数量。",
  step4_detail2: "点击数量以查看详细记录列表。",

  step5_title: "修复无效记录并重新上传",
  step5_detail1: "下载包含详细错误信息的 __bold__错误文件__bold__。",
  step5_detail2: "更正问题并仅 __bold__重新上传__bold__ 无效条目。",

  tipsTitle: "提示",
  tip1: "确保所有 __bold__必填字段__bold__ 已填写且数据格式正确。",
  tip2: "在Excel模板中 __bold__冻结窗格__bold__ 并使用 __bold__筛选器__bold__ 以便更轻松编辑。",
  tip3: "定期检查 __bold__上传历史__bold__ 以确认处理状态。",

  footer: "需要帮助？请联系管理员或查看用户指南以获取更多详细信息。"

}

export const revisionquickGuideEN = {
  title: "PO Revision Upload Quick Guide",
  subtitle: "Easily upload multiple PO requests at once using the PO Revision Upload  feature.",
  stepsTitle: "Steps to Use",

  step1_title: "Download the template",
  step1_detail1: "Choose a __bold__Request Type__bold__ (Expedite, Defer, Delay, Divert, Open, Confirm, or All).",
  step1_detail1_buyer: "Choose a __bold__Inventory Aanalyst, Vendor, SKU and Change Type__bold__. At least one filter should be selected to download the template",
  step1_detail2: "Selecting __bold__All__bold__ downloads an Excel file with separate sheets for each type.",

  step2_title: "Fill the template",
  step2_detail1: "Open the Excel file and fill in only the __bold__yellow highlighted (editable)__bold__ fields.",
  step2_detail2: "Non-editable columns are system-protected to prevent accidental changes.",

  step3_title: "Upload the file",
  step3_detail1: "Click __bold__Upload File__bold__ or drag and drop the completed Excel file.",
  step3_detail2: "The system validates your data and updates the __bold__Upload History__bold__ automatically.",

  step4_title: "Review upload summary",
  step4_detail1: "View the count of __bold__Valid__bold__ and __bold__Invalid__bold__ records.",
  step4_detail2: "Click on counts to see detailed record lists.",

  step5_title: "Fix invalid records and re-upload",
  step5_detail1: "Download the __bold__Error File__bold__ with detailed messages.",
  step5_detail2: "Correct the issues and __bold__re-upload__bold__ only the invalid entries.",

  tipsTitle: "Tips",
  tip1: "Ensure all __bold__mandatory fields__bold__ are filled and data formats are correct.",
  tip2: "__bold__Freeze panes__bold__ and use __bold__filters__bold__ in the Excel template for easier editing.",
  tip3: "Check the __bold__Upload History__bold__ regularly to confirm processing status.",

  footer: "Need help? Contact your Admin or check the user guide for more details."
};

export const revisionquickGuideCN = {
  title: "PO修订批量上传快速指南",
  subtitle: "使用 PO 修订批量上传功能，轻松一次性上传多个 PO 请求。",

  stepsTitle: "操作步骤",

  step1_title: "下载模板",
  step1_detail1: "选择一个__bold__请求类型__bold__（加急、延期、延迟、转运、打开、确认或全部）。",
  step1_detail1_buyer: "选择__bold__库存分析员、供应商、SKU 以及 FAT/Price__bold__。下载模板前，至少需要选择一个筛选条件。",
  step1_detail2: "选择__bold__全部__bold__将下载一个包含各请求类型独立工作表的 Excel 文件。",

  step2_title: "填写模板",
  step2_detail1: "打开 Excel 文件，仅填写__bold__黄色高亮（可编辑）__bold__字段。",
  step2_detail2: "不可编辑的列受系统保护，以防止误修改。",

  step3_title: "上传文件",
  step3_detail1: "点击__bold__上传文件__bold__或拖拽已完成的 Excel 文件进行上传。",
  step3_detail2: "系统将验证数据，并自动更新__bold__上传历史__bold__。",

  step4_title: "查看上传结果",
  step4_detail1: "查看__bold__有效__bold__和__bold__无效__bold__记录的数量。",
  step4_detail2: "点击对应数量可查看详细记录列表。",

  step5_title: "修正错误并重新上传",
  step5_detail1: "下载包含详细错误信息的__bold__错误文件__bold__。",
  step5_detail2: "修正问题后，仅重新上传__bold__无效记录__bold__。",

  tipsTitle: "温馨提示",

  tip1: "请确保所有__bold__必填字段__bold__均已填写，且数据格式正确。",
  tip2: "建议在 Excel 模板中使用__bold__冻结窗格__bold__和__bold__筛选__bold__功能，以便更方便地编辑。",
  tip3: "请定期查看__bold__上传历史__bold__，确认处理状态。",

  footer: "需要帮助？请联系管理员或查阅用户指南了解更多信息。"
};